export default "__VITE_ASSET__CWoMzkD5__"